// Icons
import GrayedTerribleIcon from 'assets/icons/ic_terrible_default.svg';
import GrayedBadIcon from 'assets/icons/ic_bad_default.svg';
import GrayedOkayIcon from 'assets/icons/ic_okay_default.svg';
import GrayedGoodIcon from 'assets/icons/ic_good_default.svg';
import GrayedExcellentIcon from 'assets/icons/ic_excellent_default.svg';
import TerribleIcon from 'assets/icons/ic_terrible_selected.svg';
import BadIcon from 'assets/icons/ic_bad_selected.svg';
import OkayIcon from 'assets/icons/ic_okay_selected.svg';
import GoodIcon from 'assets/icons/ic_good_selected.svg';
import ExcellentIcon from 'assets/icons/ic_excellent_selected.svg';
import { CsatFormData, CsatTranslatedText } from 'api/types';

export const handleImageType = (
  score: CsatFormData['csatScore'],
  csatScore: number,
) => {
  const isSelected = score === csatScore;

  if (isSelected) {
    switch (score) {
      case 1:
        return TerribleIcon;
      case 2:
        return BadIcon;
      case 3:
        return OkayIcon;
      case 4:
        return GoodIcon;
      case 5:
        return ExcellentIcon;
    }
  } else {
    switch (score) {
      case 1:
        return GrayedTerribleIcon;
      case 2:
        return GrayedBadIcon;
      case 3:
        return GrayedOkayIcon;
      case 4:
        return GrayedGoodIcon;
      case 5:
        return GrayedExcellentIcon;
    }
  }
};

export const getFeedbackOptions = (
  csatScore: number,
): Readonly<{ value: keyof CsatTranslatedText['text'] }[]> => {
  switch (csatScore) {
    case 1:
    case 2:
      return CSAT_FEEDBACK_NEGATIVE_OPTIONS;
    case 3:
    case 4:
      return CSAT_FEEDBACK_NEUTRAL_OPTIONS;
    case 5:
      return CSAT_FEEDBACK_POSITIVE_OPTIONS;
    default:
      return [];
  }
};

export const CSAT_OPTIONS = {
  1: 'CSAT_TERRIBLE',
  2: 'CSAT_BAD',
  3: 'CSAT_OKAY',
  4: 'CSAT_GOOD',
  5: 'CSAT_EXCELLENT',
} as const;

const CSAT_FEEDBACK_NEGATIVE_OPTIONS = [
  { value: 'CSAT_TOOK_TOO_LONG' },
  { value: 'CSAT_DID_NOT_UNDERSTAND' },
  { value: 'CSAT_UNFRIENDLY' },
  { value: 'CSAT_IMPERSONAL' },
  { value: 'CSAT_UNHELPFUL_RESPONSE' },
] as const;

const CSAT_FEEDBACK_NEUTRAL_OPTIONS = [
  { value: 'CSAT_GOOD_SOLUTION' },
  { value: 'CSAT_TOOK_TOO_LONG' },
  { value: 'CSAT_IMPERSONAL' },
  { value: 'CSAT_UNHELPFUL_RESPONSE' },
  { value: 'CSAT_EASY' },
  { value: 'CSAT_UNDERSTOOD_NEEDS' },
] as const;

const CSAT_FEEDBACK_POSITIVE_OPTIONS = [
  { value: 'CSAT_FRIENDLY_TONE' },
  { value: 'CSAT_GOOD_SOLUTION' },
  { value: 'CSAT_PERSONALIZED' },
  { value: 'CSAT_QUICK_TURNAROUND' },
  { value: 'CSAT_UNDERSTOOD_NEEDS' },
] as const;
